import axios from 'axios'
import config from '../config'
import store from '../store'
import { logoutUser } from '../util/authhelper.js'

const urlParser = document.createElement('a')
var jwt = require('jsonwebtoken')

let listenersActive = false
let lastCheckTime = Date.now()
let shouldRefresh = true
let debounceTimeout = null

export function domain (url) {
	urlParser.href = url
	return urlParser.hostname
}

export function formatCurrency (value) {
	var formatter = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'KES'
	})

	return formatter.format(value)
}

export function count (arr) {
	return arr.length
}

export function prettyDate (date) {
	var a = new Date(date)
	return a.toDateString()
}

export function formatDate (date) {
	date = new Date(date)
	var year = date.getFullYear()
	var month = (1 + date.getMonth()).toString()
	month = month.length > 1 ? month : '0' + month
	var day = date.getDate().toString()
	day = day.length > 1 ? day : '0' + day
	return day + '/' + month + '/' + year
}

export function pluralize (time, label) {
	if (time === 1) {
		return time + label
	}

	return time + label + 's'
}

window.addEventListener('mousemove', handleUserActivity, { passive: true })
window.addEventListener('keydown', handleUserActivity, { passive: true })
window.addEventListener('click', handleUserActivity, { passive: true })

function handleUserActivity () {
	// Clear existing debounce if any
	clearTimeout(debounceTimeout)

	// Set a debounce to detect when user activity pauses
	debounceTimeout = setTimeout(() => {
		const now = Date.now()

		// Only check if sufficient time has passed since last check (10 seconds)
		if (now - lastCheckTime >= 10000 && shouldRefresh) {
			console.log('one')
			if (store && store.state && store.state.token !== null) {
				console.log('one1')
				const token = store.state.token.slice(7)
				checkToken(token)
				lastCheckTime = now // Update the last check time
			} else {
				console.log('two - 0')
			}
		} else {
			console.log('two - 2')
		}
	}, 1000) // Longer debounce time reduces processing
}
export function checkToken(token) {
  const decoded = jwt.decode(token);
  if (decoded === null) return;

  const tokenExpiry = new Date(decoded.exp * 1000);
  const now = new Date();

  const diffSec = (tokenExpiry.getTime() - now.getTime()) / 1000;
  const diffMin = diffSec / 60;

  if ((diffMin <= 5 && diffMin > 0) || (diffMin <= 0 && diffMin >= -15)) {
    console.log('Refreshing token...');
    getToken(token);
  } else if (diffMin < -15) {
    console.log('Token expired too long ago. Logging out...');
    logoutUser(token);
  }

  console.log('Token minutes left:', diffMin);
}
// export function checkToken (token) {
//   var decoded = jwt.decode(token)
//   if (decoded === null) {
//     return
//   }
//   var tokenExpiry = new Date(decoded.exp * 1000)
//   var now = new Date()
//   var diffSec = (tokenExpiry.getTime() - now.getTime()) / 1000
//   var diffMin = diffSec / 60
//   if (diffMin <= config.sessionTimeout / 2 && diffMin > 0) {
//     console.log('Sending a refresh token request')
//     getToken(token)
//   }
//   if (diffMin <= -5) {
//     logoutUser(token)
//   }
//   console.log(diffMin)
// }

/* export function checkToken (token) {
	var decoded = jwt.decode(token)
	if (decoded === null) {
		return
	}
	var tokenExpiry = new Date(decoded.exp * 1000)
	var now = new Date()
	var diffSec = (tokenExpiry.getTime() - now.getTime()) / 1000
	var diffMin = diffSec / 60
	if (diffMin <= config.sessionTimeout / 2 && diffMin > 0) {
		console.log('Sending a refresh token request')
		getToken(token)
	}
	if (diffMin <= -5) {
		logoutUser(token)
	}
	console.log(diffMin)
} */

/* export function checkToken (token) {
	var decoded = jwt.decode(token)
	if (decoded === null) {
		return
	}
	var tokenExpiry = new Date(decoded.exp * 1000)
	var now = new Date()
	var diffSec = (tokenExpiry.getTime() - now.getTime()) / 1000
	var diffMin = diffSec / 60
	if (diffMin <= config.sessionTimeout / 2 && diffMin > 0) {
		console.log('Sending a refresh token request')
		getToken(token)
	}
	if (diffMin <= -5) {
		logoutUser(token)
	}
	console.log(diffMin)
} */

function getToken (token) {
	var url = config.serverURI + '/token/refresh-token'
	axios
		.post(url, { token })
		.then(response => {
			var data = response.data
			if (data.error) {
				var errorName = data.error
				if (errorName) {
					console.log('error')
				} else {
					console.log('error')
				}

				return
			}

			/* Setting user in the state and caching record to the localStorage */
			if (data.token) {
				var token = 'Bearer ' + data.token

				store.state.token = token
				store.state.user = data.user

				if (window.localStorage) {
					window.localStorage.setItem('user', JSON.stringify(data.user))
					window.localStorage.setItem('token', token)
				}
			}
		})
		.catch(error => {
			console.log(error)
		})
}
